import { UseInfiniteQueryResult, useInfiniteQuery } from '@tanstack/react-query'

import { ApiError } from 'src/config/request'

import { Fetcher, UseInfiniteRequestOptions } from './types'

export const useInfiniteRequest = <Response>(
  key: [string, ...string[]],
  fetcher: Fetcher<Response>,
  options: UseInfiniteRequestOptions<Response>
): UseInfiniteQueryResult<Response, ApiError> =>
  useInfiniteQuery<Response, ApiError>(key, fetcher, { ...options })
